'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Notification;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _closeIcon = require('./closeIcon');

var _closeIcon2 = _interopRequireDefault(_closeIcon);

var _ButtonIcon = require('./../ButtonIcon');

var _ButtonIcon2 = _interopRequireDefault(_ButtonIcon);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _icons = require('./icons');

var _icons2 = _interopRequireDefault(_icons);

var _title = require('./title');

var _title2 = _interopRequireDefault(_title);

var _description = require('./description');

var _description2 = _interopRequireDefault(_description);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* Notifications serve as a confirmation mechanism & feedback that comes into the page at the top.
*/


function Notification(props) {
  var className = props.className,
      style = props.style,
      icon = props.icon,
      title = props.title,
      description = props.description,
      onRequestClose = props.onRequestClose;

  function getClassName() {
    return (0, _classnames2.default)('rainbow-notification', className);
  }

  return _react2.default.createElement('div', {
    className: getClassName(),
    style: style
  }, _react2.default.createElement('a', {
    className: 'rainbow-notification_anchor'
  }, _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!icon
  }, _react2.default.createElement(_icons2.default, {
    icon: icon
  })), _react2.default.createElement('span', null, _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!title
  }, _react2.default.createElement(_title2.default, {
    text: title
  })), _react2.default.createElement(_RenderIf2.default, {
    isTrue: !!description
  }, _react2.default.createElement(_description2.default, {
    text: description
  })))), _react2.default.createElement(_ButtonIcon2.default, {
    className: 'rainbow-notification_close',
    icon: _react2.default.createElement(_closeIcon2.default, null),
    size: 'small',
    title: 'Close',
    onClick: onRequestClose
  }));
}

Notification.propTypes = {
  /** The icon to show if it is passed. It is displayed in the left of the component.
  * It must be one of this values info, success, warning, error,
  * or any svg icon. */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.oneOf(['info', 'success', 'warning', 'error'])]),

  /** The title that appears in the notification. */
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /** The description that appears in the notification. */
  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /** The action triggered when the close button is clicked. */
  onRequestClose: _propTypes2.default.func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object
};
Notification.defaultProps = {
  icon: null,
  title: null,
  description: null,
  onRequestClose: function onRequestClose() {},
  className: undefined,
  style: undefined
};